import { getNoDataTextForCustomToken, getTokenSymbol } from 'pages/raas/DeploymentDetails/utils';
import { useRaasDeployment, useRaasMetrics } from 'pages/raas/hooks';
import { useParams } from 'react-router-dom';
import { Metric } from 'shared/components/metric';
import { Panel } from 'shared/types/protoc-gen/raas-metrics';

import { useDateRangeFilterOptions } from '../../hooks/useDateRangeFilterOptions';
import { DateFilterVariant } from '../../store';

export const WithdrawalVolumeEthGrowthMetric = () => {
  const { rollupId } = useParams();
  const { data: rollup } = useRaasDeployment();

  const { end, start, step, timeframe } = useDateRangeFilterOptions(
    DateFilterVariant.BRIDGE_METRICS_WITHDRAWALS_SECTION,
  );

  const { data: result, isPending } = useRaasMetrics({
    panel: Panel.PANEL_OPSTACK_WITHDRAWAL_VOLUME,
    timeframe,
    rollupId,
    start,
    end,
    step,
  });

  return (
    <Metric
      data={!rollup?.name.includes('hashkey') ? result : undefined}
      description={`Growth trend of total withdrawal volume in ${getTokenSymbol(rollup)}`}
      id="withdrawals-volume-growth"
      loading={isPending}
      noDataText={getNoDataTextForCustomToken(rollup)}
      title={`Withdrawals volume (${getTokenSymbol(rollup)}) growth`}
    />
  );
};
